export default "__VITE_ASSET__20209d29__"